import benjyLogo from '../../../../assets/img/benjy-logo.jpg'

export const useHelpers = () => {

    const defaultFontSize = 10
    const titleFontSize = 25
    const widthPage = 180
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const _drawHeaderPaymentReceptionTicket = (docPdf, data, posY) => {
        
        // Marco 
        docPdf.rect(10, 10, 260, 195); // x=10, y=20, ancho=100, alto=50

        // Logo
        const imgWidth = 55;
        const imgHeight = 20;
        docPdf.addImage(benjyLogo, 'JPG', 20, posY-13, imgWidth, imgHeight);

        // Membrete principal
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('PREDIO PRIVADO BENJY', 140, posY, { align: 'center' }); // Centrado
        docPdf.setFontSize(defaultFontSize);

        posY += 5

        docPdf.setFont("helvetica", "normal");
        docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY, { align: 'center' });
        docPdf.text('TEL: 24581568 extensión 1', 140, posY+5, { align: 'center' });

        posY += 20
        
        // Fecha
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('FECHA', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_fecha_recibo, 60, posY+4, { align: 'left' });
        
        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(100, posY, 35, 5, 'F');
        docPdf.rect(100, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('HORA', 110, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_hora_recibo, 140, posY+4, { align: 'left' });
        
        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ESTADO', 185, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_check, 220, posY+4, { align: 'left' });

        posY += 10

        // Cliente
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 130, 5); //240
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CLIENTE', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.info_cliente, 58, posY+4, { align: 'left' });
        
        // Autoridad
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(150, posY, 35, 5, 'F');
        docPdf.rect(150, posY, 110, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('AUTORIDAD', 155, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.nombre_autoridad, 190, posY+4, { align: 'left' });
        
        posY += 5

        // Operado por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 130, 5); //240
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OPERADOR', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.usuario_creo, 58, posY+4, { align: 'left' });
        
        // Por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(150, posY, 35, 5, 'F');
        docPdf.rect(150, posY, 110, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('POR', 155, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q. ' + parseFloat(data.movimiento_quetzales).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 190, posY+4, { align: 'left' });
        
        posY += 5

        // Concepto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 240, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CONCEPTO', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`PARQUEO / CONSIGNACIÓN ${data.tarifa_aplicada}`, 58, posY+4, { align: 'left' });

    }

    const _drawIdentifiersPaymentReceptionTicket = (docPdf, data, posY) => {

        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(defaultFontSize);
        docPdf.text(`IDENTIFICADOR ${data.identificador}`, 215, posY);
        docPdf.text(`RECIBO NO. ${data.idtransaction}`, 215, posY+5);

    }

    const _drawBalanceInfoPaymentReceptionTicket = (docPdf, data, posY) => {
        
        // console.log('_drawBalanceInfoPaymentReceptionTicket', data)

        // Alquiler
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 23, 5, 'F');
        docPdf.rect(180, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('PARQUEO', 183, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.total_por_dias).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 205, posY+4, { align: 'left' });

        posY += 5

        // Otros Gastos
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 23, 5, 'F');
        docPdf.rect(180, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('GASTOS', 183, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.other_expense_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 205, posY+4, { align: 'left' });
        
        posY += 5

        // Total a pagar
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 23, 5, 'F');
        docPdf.rect(180, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL', 183, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.total_pagar).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 205, posY+4, { align: 'left' });

        posY += 5

        // Descuentos
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 23, 5, 'F');
        docPdf.rect(180, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('DESCUEN.', 183, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.info_descuento).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 205, posY+4, { align: 'left' });
        
        posY += 5

        // Recibido
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 23, 5, 'F');
        docPdf.rect(180, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('RECIBIDO', 183, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q '+parseFloat(data.total_recibido).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 205, posY+4, { align: 'left' });
        
        posY += 5

        // Saldo
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 23, 5, 'F');
        docPdf.rect(180, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('SALDO', 183, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(String('Q ' + parseFloat(data.saldo_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 205, posY+4, { align: 'left' });

    }

    const _drawObservationsPaymentReceptionTicket = (docPdf, data, justifyTextBox, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 70);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OBSERVACIONES', 183, posY+4, { align: 'left' });
        
        posY += 5
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.movimiento_observaciones || '', 181, posY+4, 70, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

        posY += 35
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.aprobacion_observaciones || '', 181, posY+4, 70, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

    }

    const _drawExpensesReceptionTicket = (docPdf, data, posY) => {
        
        for(let i = 0; i<data.infoExpenses.length; i++){
            // Saldo
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(131, posY, 23, 5, 'F');
            docPdf.rect(131, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text(`${data.infoExpenses[i].expense_description}`, 133, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(String('Q ' + parseFloat(data.infoExpenses[i].costo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 155, posY+4, { align: 'left' });

            posY += 5
        }

        
    }

    const _drawInfoVehicleReceptionTicket = (docPdf, data, posY) => {
        
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('PLACA', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.vehicle_placa, 39, posY+4, { align: 'left' });

        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MARCA', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.vehicle_marca, 91, posY+4, { align: 'left' });

        posY += 5

        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('LINEA', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.vehicle_linea, 39, posY+4, { align: 'left' });

        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('COLOR', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.vehicle_color, 91, posY+4, { align: 'left' });
        
        posY += 5

        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MODELO', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.vehicle_modelo, 39, posY+4, { align: 'left' });

        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CHASIS', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.vehicle_chasis, 91, posY+4, { align: 'left' });
        
    }
    
    const _drawInfoPaymentReceptionTicket = (docPdf, data, justifyTextBox, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TIPO', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_tipo, 39, posY+4, { align: 'left' });

        // Monto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONTO', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 91, posY+4, { align: 'left' });

        posY += 5

        // Moneda
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONEDA', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_moneda, 39, posY+4, { align: 'left' });

        // Tipo cambio
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAMBIO', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_tipo_cambio).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 91, posY+4, { align: 'left' });
        
        posY += 5

        // Total Queztales
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL Q.', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_quetzales).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 39, posY+4, { align: 'left' });

        // Total Dolares
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL $.', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_dolares).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 91, posY+4, { align: 'left' });
        
        posY += 10

        // Numero de boleta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BOLETA', 21, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.boleta_numero || '---', 39, posY+4, { align: 'left' });

        // Referencia ACH
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 17, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ACH', 74, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_referencia_ach || '---', 91, posY+4, { align: 'left' });

        posY += 5

        // Banco
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 10, 'F');
        docPdf.rect(20, posY, 108, 10);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BANCO', 21, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.descripcion_banco || '---', 39, posY+4, { align: 'left' });
        justifyTextBox(docPdf, data.descripcion_banco || '---', 39, posY+4, 80, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

        posY += 10

        // Cuenta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 18, 10, 'F');
        docPdf.rect(20, posY, 108, 10);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAJA', 21, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.descripcion_caja || '---', 39, posY+4, { align: 'left' });
        justifyTextBox(docPdf, data.descripcion_caja || '---', 39, posY+4, 80, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
        
    }

    const _drawFooterPaymentReceptionTicket = (docPdf, data, justifyTextBox, posY) => {
        
        docPdf.line(20, posY, 90, posY);
        docPdf.text(`FIRMA AUTORIZADA`, 40, posY+7, { align: 'left' });
        docPdf.text('SELLO', 125, posY+4, { align: 'left' });

        // posY += 20
        // docPdf.setFont("helvetica", "normal");
        // const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
        // justifyTextBox(docPdf, text, 20, posY, 240, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })
    }

    const drawPaymentReceptionTicket = (pdfManager, data) => {
        
        const { pdfLandscapeDoc, justifyTextBox } = pdfManager

        // console.log('drawPaymentReceptionTicket ----- ', data)

        _drawHeaderPaymentReceptionTicket(pdfLandscapeDoc, data, 30)
        _drawIdentifiersPaymentReceptionTicket(pdfLandscapeDoc, data, 30)
        _drawBalanceInfoPaymentReceptionTicket(pdfLandscapeDoc, data, 90)
        _drawInfoVehicleReceptionTicket(pdfLandscapeDoc, data, 90) // 130
        _drawInfoPaymentReceptionTicket(pdfLandscapeDoc, data, justifyTextBox, 110) // 90
        _drawObservationsPaymentReceptionTicket(pdfLandscapeDoc, data, justifyTextBox, 130)
        _drawExpensesReceptionTicket(pdfLandscapeDoc, data, 90)
        _drawFooterPaymentReceptionTicket(pdfLandscapeDoc, data, justifyTextBox, 185)

        pdfLandscapeDoc.save(`RECIBO PREDIO ${data.identificador}.pdf`);
    }
    
    return Object.freeze({
        getCurrentDate,
        drawPaymentReceptionTicket
    })
}